// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__119yL","notes":"Notes_notes__1dBQs","note":"Notes_note__1pVQ8","markdown":"Notes_markdown__2i7z7"};